import styled from "styled-components";

export const Button = styled.a`
    font-family: 'Bebas Neue', sans-serif;
`